document.addEventListener('DOMContentLoaded', function() {
  // Remove item
  document.querySelectorAll('.cart-remove-button').forEach(btn => {
    btn.addEventListener('click', function() {
      const wrapper = btn.closest('[data-key]');
      const key = wrapper.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(()=> window.location.reload())
      .catch(console.error);
    });
  });

  // + / – quantity
  document.querySelectorAll('.main-cart__line-item__quantity').forEach(wrapper => {
    const key = wrapper.getAttribute('data-key');
    const input = wrapper.querySelector('.quantity-input');
    wrapper.querySelectorAll('.decrement, .increment').forEach(btn => {
      btn.addEventListener('click', function() {
        let qty = parseInt(input.value) || 0;
        qty += btn.classList.contains('increment') ? 1 : -1;
        if (qty < 0) qty = 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(()=> window.location.reload())
        .catch(console.error);
      });
    });
  });
});